import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../../components/design";

const ContinueAddingPopup = ({
  setShowSkipStepPopup,
  handleSkipStep,
  skipStepLoading,
}) => {
  const { _t } = useTranslator();
  return (
    <Modal
      open
      onClose={() => setShowSkipStepPopup(false)}
      dismissible={false}
      title={_t("documentAnalysisIsTakingMoreTimeThenExpected")}
      description={_t("doYouWantToSkipThisStep")}
      actions={
        <>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => setShowSkipStepPopup(false)}
          >
            {_t("stayHere")}
          </Button>
          <Button size="lg" loading={skipStepLoading} onClick={handleSkipStep}>
            {skipStepLoading ? _t("skippingStep") : _t("skipStep")}
          </Button>
        </>
      }
    />
  );
};

export default ContinueAddingPopup;
